<template>
  <div>
    <div v-if="!this.loading">
      <div v-if="this.search_status">
        <card>
          <b-tabs class="full-width-ysy" @activate-tab="setActiveTab" pills :value=activeTabArgon>
            <b-tab v-for="link in tabs.links" :title="link.text" :key="link.index">
              <card style="margin-top: 5%">
                <template slot="header">
                  <!-- Subtitle -->
                  <h6 class="surtitle">Overview</h6>
                  <!-- Title -->
                  <h5 class="h3 mb-0">Number of requests sent for '{{link.text.split('|')[0]}}'
                    configuration, Last run at {{new
                    Date(link.timestamp*1000).toISOString().split('T')[0]}} - {{new
                    Date(link.timestamp*1000).toISOString().split('T')[1].split('.')[0]}}</h5>
                </template>
                <div class="chart">
                  <line-chart
                    v-if="activeTabArgon===link.index"
                    :height="350"
                    :chart-data="tabs.reportChart[link.index].chartData"
                    :extra-options="extraOptions"
                    :key="update_key_switch"
                  >
                  </line-chart>
                </div>
              </card>
            </b-tab>
          </b-tabs>
        </card>
      </div>
      <div v-else>
        <card>
          <div color="danger">
            Sorry, but it's too early to create a report
          </div>
        </card>
      </div>
    </div>

    <div v-if="this.loading">
      <div class="spinner-grow" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
</template>

<script>
    import LineChart from '../Argon/Charts/LineChart';
    import * as chartConfigs from '../Argon/Charts/config';
    import {refreshIdToken} from '../../util/utilsYsy';

    export default {
        name: "ReportTableSalesLinkedIn",
        data() {
            return {
                UpdateTabsArgon: '',
                update_key_switch: '',
                activeTabArgon: 0,
                loading: false,
                search_status: true,
                tabs: {
                    reportChart: [],
                    links: [],
                },
                extraOptions: {
                    responsive: true
                }
            };
        },
        components: {LineChart},
        mounted() {
            if (localStorage.report_tabs_sales) {
                console.log('Trying the get the data for locatStorage')
                this.tabs = JSON.parse(localStorage.report_tabs_sales);
                this.search_status = true;
                this.loading = false;
                this.update_key_switch = Date.now()
            }
        },
        methods: {
            createChartObject(labels, datasets) {
                return {
                    chartData: {
                        labels: labels,
                        datasets: [datasets],
                    },
                    extraOptions: chartConfigs.blueChartOptions,
                }
            },
            setActiveTab(event) {
                this.activeTabArgon = event;
            },
            refreshIdToken,
            getAllUrlParams(url) {

                // get query string from url (optional) or window
                var queryString = url ? url.split('?')[1] : window.location.search.slice(1);

                // we'll store the parameters here
                var obj = {};

                // if query string exists
                if (queryString) {

                    // stuff after # is not part of query string, so get rid of it
                    queryString = queryString.split('#')[0];

                    // split our query string into its component parts
                    var arr = queryString.split('&');

                    for (var i = 0; i < arr.length; i++) {
                        // separate the keys and the values
                        var a = arr[i].split('=');

                        // set parameter name and value (use 'true' if empty)
                        var paramName = a[0];
                        var paramValue = typeof (a[1]) === 'undefined' ? true : a[1];

                        // (optional) keep case consistent
                        paramName = paramName.toLowerCase();
                        if (typeof paramValue === 'string') paramValue = paramValue.toLowerCase();

                        // if the paramName ends with square brackets, e.g. colors[] or colors[2]
                        if (paramName.match(/\[(\d+)?\]$/)) {

                            // create key if it doesn't exist
                            var key = paramName.replace(/\[(\d+)?\]/, '');
                            if (!obj[key]) obj[key] = [];

                            // if it's an indexed array e.g. colors[2]
                            if (paramName.match(/\[\d+\]$/)) {
                                // get the index value and add the entry at the appropriate position
                                var index = /\[(\d+)\]/.exec(paramName)[1];
                                obj[key][index] = paramValue;
                            } else {
                                // otherwise add the value to the end of the array
                                obj[key].push(paramValue);
                            }
                        } else {
                            // we're dealing with a string
                            if (!obj[paramName]) {
                                // if it doesn't exist, create property
                                obj[paramName] = paramValue;
                            } else if (obj[paramName] && typeof obj[paramName] === 'string') {
                                // if property does exist and it's a string, convert it to an array
                                obj[paramName] = [obj[paramName]];
                                obj[paramName].push(paramValue);
                            } else {
                                // otherwise add the property
                                obj[paramName].push(paramValue);
                            }
                        }
                    }
                }

                return obj;
            },
            async getStatPerSearch() {
                const path = this.BACKEND_YSY + "/linkedin/get-user-state";
                let headers = {
                    'Content-type': 'application/json',
                    'Authorization': `Bearer ${localStorage.id_token}`
                };
                await this.$http
                    .post(path, {
                        email_linkedin: this.$store.getters.getEmailLinkedin,
                        linkedin_type: 'sales'
                    }, {headers})
                    .then(res => {
                        if (res.data.length === 1) {
                            this.extraOptions.responsive = false;
                        }
                        if (res.data.search_status === 404) {
                            this.search_status = false;
                            this.loading = false;
                            return
                        }
                        for (let i = 0; i < Object.keys(res.data).length; i++) {
                            this.tabs.links.push({
                                text: res.data[i]['reports'][0]['ysySearchName'] + '|' + res.data[i]['reports'][0]['type'],
                                index: i,
                                timestamp: res.data[i]['timestamp']
                            });
                            let tmp_labels = [];
                            let tmp_data = {
                                label: '#Requests',
                                data: [],
                                lineTension: 0
                            };
                            res.data[i]['reports'].forEach(function (report) {
                                tmp_labels.push(report['Date'])
                                tmp_data.data.push(report['#Requests'])
                            });
                            this.tabs.reportChart.push(this.createChartObject(tmp_labels, tmp_data))
                        }
                        localStorage.report_tabs_sales = JSON.stringify(this.tabs);
                        this.search_status = true;
                        this.loading = false
                    })
                    .catch(async error => {
                        const self = this;
                        if (error.response.status === 401) {
                            console.error('Unauthorized', error.response.data);
                            await this.refreshIdToken().then(function (result) {
                                console.log("res promise", result); // "Stuff worked!"
                                self.getStatPerSearch();
                            }, function (err) {
                                console.log("it broke", err); // Error: "It broke"
                                self.$router.push({name: 'login'});
                            });

                        }
                    });
            }
        },
        computed: {
            isLoggedIn: function () {
                return this.$store.getters.isLoggedIn
            }
        },
        created() {
            if (!localStorage.report_tabs_sales) {
                console.log('loading the data in local store');
                this.getStatPerSearch();
                console.log(localStorage);
                this.update_key_switch = Date.now()
            } else {
                console.log('No need for axios - Data in local store');
                this.tabs = JSON.parse(localStorage.report_tabs_sales);
                this.search_status = true;
                this.loading = false;
                this.update_key_switch = Date.now()
            }

        }
    };
</script>

<style>
  .full-width-ysy .nav-pills .nav-link {
    margin-bottom: 10px;
  }
</style>
